<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <ClientOnly>
    <CommonsToastView />
    <CommonsMockApiInspector />
  </ClientOnly>
</template>
